import CTA from '~/constants/appearance'

function getButtonColor (value) {
  if(value) {
    if (value.startsWith(CTA.DARK)) {
      return CTA.PRIMARY
    }
    return CTA.SECONDARY
  }
  return null
}

export default getButtonColor
